const ROUTES = [
  {
    routeTarget: "/",
    routeName: "Home",
  },
  {
    routeTarget: "/books",
    routeName: "Books",
  },
  {
    routeTarget: "/about",
    routeName: "About",
  },
];

export default ROUTES;
